import React, { useState, useEffect, useRef } from "react";
import logo from "./assets/logo_kairos_white.png";

export default function KairosChat_L3() {
  const activeLevel = 3;
  const [messages, setMessages] = useState([]);

  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const listRef = useRef(null);
  const bubbleRefs = useRef([]);
  const [bubbleHeights, setBubbleHeights] = useState([]);

  const formatKairosText = (text) => {
    const lastQ = text.lastIndexOf("?");
    if (lastQ === -1) {
      return <span style={{ lineHeight: "1.25" }}>{text}</span>;
    }

    const body = text.slice(0, lastQ + 1).trim();
    const question = text.slice(lastQ + 1).trim();

    return (
      <span style={{ lineHeight: "1.25" }}>
        {body}
        {question ? " " + question : ""}
      </span>
    );
  };

  const TypingIndicator = () => (
  <div
    style={{
      alignSelf: "flex-start",
      background: "#fff",
      padding: "10px 14px",
      borderRadius: 12,
      fontSize: 22,
      display: "flex",
      gap: 4,
      animation: "fadeInUp .4s ease",
    }}
  >
    <span className="dot" style={{ animationDelay: "0s" }}>•</span>
    <span className="dot" style={{ animationDelay: "0.2s" }}>•</span>
    <span className="dot" style={{ animationDelay: "0.4s" }}>•</span>
  </div>
);

  useEffect(() => {
    if (!listRef.current) return;

    const timeout = setTimeout(() => {
      listRef.current.scrollTo({
        top: listRef.current.scrollHeight,
        behavior: "smooth",
      });
    }, 100);

    return () => clearTimeout(timeout);
  }, [messages]);

  useEffect(() => {
    if (!bubbleRefs.current) return;

    const heights = bubbleRefs.current.map(
      (el) => (el ? el.offsetHeight : 0)
    );

    setBubbleHeights(heights);
  }, [messages]);

  const sendMessage = async () => {
  console.log(">>> SEND L1 EXECUTAT");

  const text = input.trim();
  if (!text) return;

  setMessages((prev) => [...prev, { sender: "user", text }]);
  setInput("");
  setIsTyping(true);

  try {
    const res = await fetch("https://kairos-backend-w90r.onrender.com/kairos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        text,
        level: "L3_BYPASS",
      }),
    });

    console.log(">>> FETCH L1 TRIMIS", text);

    const data = await res.json();
let reply = data.kairos || "...";
if (typeof reply !== "string") reply = String(reply || "");

    setMessages((prev) => [
      ...prev,
      { sender: "kairos", text: reply },
    ]);
    setIsTyping(false);
  } catch (e) {
    console.log(">>> FETCH L1 EROARE", e);

    setMessages((prev) => [
      ...prev,
      { sender: "kairos", text: "Connection error. Try again." },
    ]);
    setIsTyping(false);
  }
};

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div
  className="kairos-wrapper"
  style={{ minHeight: "100vh", overflowY: "auto", overflowX: "hidden" }}
>
      
      {/* FIXED HEADER */}
<div style={styles.headerBar}>
  
  <img
  src={logo}
  alt="Kairos Logo"
  style={{
    ...styles.headerLogo,
    cursor: "pointer",
    transition: "opacity 0.25s ease",
  }}
  onClick={() => (window.location.href = "/")}
  onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.6")}
  onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
/>

  {/* NIVEL — DREAPTA */}
  <div style={styles.headerLevels}>
    <div style={{ ...styles.levelDot, ...(activeLevel === 1 && styles.activeDot) }}>1</div>
    <div style={{ ...styles.levelDot, ...(activeLevel === 2 && styles.activeDot) }}>2</div>
    <div style={{ ...styles.levelDot, ...(activeLevel === 3 && styles.activeDot) }}>3</div>
  </div>

</div>

      {/* MESSAGE LIST */}
      <div ref={listRef} style={styles.messages}>
        {messages.map((m, i) => (
          <div
  key={i}
  ref={(el) => (bubbleRefs.current[i] = el)}
  className="chat-text-mobile"
  style={{
    ...styles.bubble,
    ...(m.sender === "kairos" ? styles.kairos : styles.user),
    borderRadius:
      bubbleHeights[i] && bubbleHeights[i] > 42
        ? "20px"
        : "9999px",
  }}
>
  {m.sender === "kairos"
    ? formatKairosText(m.text)
    : m.text}
</div>

        ))}

        {isTyping && <TypingIndicator />}
      </div>

      {/* FIXED INPUT */}
      <div
        style={{
          width: "min(760px, 92vw)",
          position: "fixed",
          bottom:40,
          left: "50%",
          transform: "translateX(-50%)",
          background: "#fff",
          padding: "0 10px 0",
          zIndex: 1000,
        }}
      >
        <div
  className="kairos-input-wrapper"
  style={{
    display: "flex",
    alignItems: "center",
    width: "80%",
    margin: "0 auto",
    background: "#fff",
    border: "1px solid #d0d0d0",
    borderRadius: "9999px",
    padding: "13px 10px",
    height: "30px",
    boxShadow: "0px -2px 3px rgba(0, 0, 0, 0.06)",
  }}
>
          <textarea
  className="kairos-input-field"
  value={input}
  onChange={(e) => setInput(e.target.value)}
  onKeyDown={onKeyDown}
  placeholder="Speak..."
  rows={1}
  style={{
    flex: 1,
    resize: "none",
    border: "none",
    outline: "none",
    fontSize: 16,
    fontFamily: "Sans-serif",
    background: "transparent",
    padding: "8px 14px",
    height: "20px",
    overflow: "hidden",
    lineHeight: "20px",
  }}
/>

          <button className="send-button" onClick={sendMessage}>
            <div className="triangle"></div>
          </button>
        </div>
      </div>

      <style>
  {`
    html, body {
      height: 100%;
      margin: 0;
      padding: 0;
      overflow-y: auto;
      overflow-x: hidden;
    }

    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(6px); }
      to { opacity: 1; transform: translateY(0); }
    }

    .dot {
  display: inline-block;
  opacity: 0.25;
  animation: blink 1.4s infinite ease-in-out;
}

@keyframes blink {
  0%   { opacity: 0.25; }
  20%  { opacity: 1; }
  100% { opacity: 0.25; }
}

    /* SCROLLBAR CUSTOM — gri ultra-deschis */
    ::-webkit-scrollbar {
      width: 8px;
    }
    ::-webkit-scrollbar-track {
      background: #f7f7f7;
    }
    ::-webkit-scrollbar-thumb {
      background: #dcdcdc;
      border-radius: 4px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
    }
    * {
      scrollbar-width: thin;
      scrollbar-color: #dcdcdc #f7f7f7;
    }

     /* MOBILE FIX — font mai mare în baloane și input */
@media (max-width: 600px) {
      
  /* ✔ PRIORITATEA #1 — Spațiere între baloane */
  .kairos-message {
    margin-bottom: 6px !important;
  }

  /* ✔ PRIORITATEA #2 — Font baloane */
  .chat-text-mobile {
    font-size: 16px !important;
    line-height: 1.4 !important;
  }

    /* ✔ PRIORITATEA #3 — Input bar mai subțire */
  .kairos-input-wrapper {
    padding: 8px 12px !important;
    height: 30px !important;
  }

  /* ✔ PRIORITATEA #4 — Font input */
  .chat-input {
    font-size: 16px !important;
  }

  /* ✔ PRIORITATEA #5 — Buline nivel mai mici */
  .level-dot {
    width: 24px !important;
    height: 24px !important;
    font-size: 13px !important;
  }

  /* ✔ PRIORITATEA #6 — Aliniere baloane */
  
  /* Kairos bubble — stânga */
  .kairos-message.kairos {
    max-width: 82% !important;
    margin-right: auto !important;
    margin-left: 6px !important;
  }

  /* User bubble — dreapta */
  .kairos-message.user {
    max-width: 82% !important;
    margin-left: auto !important;
    margin-right: 6px !important;
  }
    
  /* ✔ BONUS — fade modern */
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(3px); }
    to   { opacity: 1; transform: translateY(0); }
  }
}
  `}
</style>
    </div>
  );
}

/* STYLES */
const styles = {
  page: {
    height: "100vh",
    width: "100vw",
    background: "#fff",
    color: "#222",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "auto",
    overflowX: "hidden",
    fontFamily: "Carlito, sans-serif",
    paddingTop: "48px",   // ← FIXEAZĂ TOT
},

  headerWrapper: {
    width: "100vw",
    background: "#222",
    padding: "8px 0",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999
  },

  logo: {
    height: 30,
    filter: "brightness(0) invert(1)"
  },

  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  messages: {
  width: "min(760px, 92vw)",
 

  marginTop: 70,
  paddingLeft: 10,
  paddingRight: 10,
  paddingBottom: 0,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 14,
  overflow: "visible"
},

  bubble: {
    maxWidth: "86%",
    padding: "10px 14px",
    borderRadius: 12,
    fontSize: 15,
    lineHeight: 1.45,
    animation: "fadeInUp .4s ease",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },

  kairos: {
    alignSelf: "flex-start",
    background: "#fff",
    border: "none",
    color: "#222",
  },

  user: {
    alignSelf: "flex-end",
    background: "#fff",
    border: "1px solid #222",
    color: "#222",
  },

  inputRow: {
    width: "min(760px, 92vw)",
    position: "fixed",
    bottom: 80,
    left: "50%",
    transform: "translateX(-50%)",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    padding: "12px",
    zIndex: 1000,
  },

  input: {
    resize: "none",
    padding: "12px 20px",
    fontSize: 16,
    fontFamily: "Carlito, sans-serif",
    border: "1px solid #d0d0d0",
    borderRadius: "9999px",
    outline: "none",
    background: "#ffffff",
    height: "48px"
  },

  send: {
    padding: "10px 18px",
    fontSize: 16,
    borderRadius: 10,
    border: "none",
    background: "#222",
    color: "#fff",
    cursor: "pointer",
  },

  footer: {
    marginTop: 20,
    marginBottom: 90,
    textAlign: "center",
    fontSize: "11px",
    lineHeight: "1.3",
    color: "#999",
    fontFamily: "Carlito, sans-serif",
    width: "min(760px, 92vw)",
  },
  
levelLabel: {
  position: "fixed",
  top: 95,
  right: 20,
  fontSize: "0.75rem",
  opacity: 0.45,
  fontWeight: 500,
  userSelect: "none",
  zIndex: 999,
},

headerBar: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "48px",
  background: "#222",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 18px",
  zIndex: 2000,
},

headerLogo: {
  height: 32,
},

headerLevels: {
  display: "flex",
  gap: "6px",
  alignItems: "center",
  marginRight: "30px",   // mută bulinele stânga
},

levelDot: {
  width: 20,
  height: 20,
  borderRadius: "50%",
  border: "2px solid #aaa",
  color: "#aaa",
  fontSize: 12,
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 0.4,
},

activeDot: {
  background: "#7e7e7eff",   // gri plin
  borderColor: "#7e7e7eff",  // contur dispare în gri
  color: "#000",        // clar pe gri
  opacity: 1,
},
};